// extracted by mini-css-extract-plugin
export default {"card":"CardTwo_card__cKSkr","image":"CardTwo_image__tE9Fl","content":"CardTwo_content__hdgf1"};